import sanitizeHtml from 'sanitize-html';
export class SanitizerService {
    sanitize(unsafeHtml, options) {
        const sanitizerConfig = {
            allowedAttributes: {
                ...sanitizeHtml.defaults.allowedAttributes,
                '*': ['style', 'class'],
                'mg-icon': ['icon', 'size', 'variant', 'variant-style', 'color'],
                table: ['bgcolor', 'cellspacing', 'cellpadding', 'border'],
                tr: ['bgcolor'],
                th: ['colspan', 'rowspan', 'bgcolor'],
                td: ['colspan', 'rowspan', 'bgcolor'],
            },
            allowedTags: [...sanitizeHtml.defaults.allowedTags, 'img', 'mg-icon'],
            allowVulnerableTags: false,
            allowedSchemesByTag: {
                img: ['http', 'https', 'data'],
            },
        };
        if (options?.allowUnsafeStyleTag) {
            // This is needed because some custom HTML use this tag and it is still safer to sanitize the rest
            sanitizerConfig.allowedTags.push('style');
            sanitizerConfig.allowVulnerableTags = true;
        }
        // TODO: replace this when the CORE lib will be created
        // (https://gitlab.mgdis.fr/core/core-ui/core-ui/-/issues/353)
        return sanitizeHtml(unsafeHtml, sanitizerConfig);
    }
}
//# sourceMappingURL=sanitizer-service.js.map